import { AppContext } from "01Data/AppData";
import IconPassword from "@mui/icons-material/Edit";
import IconAccounts from "@mui/icons-material/Group";
import IconList from "@mui/icons-material/List";
import IconLogout from "@mui/icons-material/Logout";
import IconLeakage from "@mui/icons-material/WaterDamage";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  styled,
} from "@mui/material";
import { useContext } from "react";
import { Link } from "react-router-dom";

const MyLink = styled(Link)(({ theme }) => ({
  textDecoration: "none",
  color: theme.palette.text.secondary,
}));

type Props = {
  name: string;
  path: string;
  icon: any;
  onClick?: any;
};

const Item = (props: Props) => {
  const handleOnClick = () => {
    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <MyLink to={props.path} key={props.path} onClick={handleOnClick}>
      <ListItem button>
        <ListItemIcon>{props.icon}</ListItemIcon>
        <ListItemText primary={props.name} />
      </ListItem>
    </MyLink>
  );
};

const MenuItem = ({ setOpen }: { setOpen: any }) => {
  const a = useContext(AppContext);
  const accounts = a.dataAdmin.accounts;
  const andon = a.dataAdmin.andon;

  const handleLogout = () => {
    a.account.SignOut();
  };

  const handleAccountList = () => {
    if (accounts.andonAccount) {
      // アンドン表示中にアカウント一覧をクリックした場合に一覧に戻る
      accounts.andonAccount = null;
      accounts.andonID = null;
      andon.Clear();
      accounts.changed();
    }
    setOpen(false);
  };

  return (
    <List>
      <Item
        name="漏水発生一覧"
        path="/admin/leakage"
        icon={<IconLeakage />}
        onClick={() => setOpen(false)}
      />
      <Item
        name="ID一覧"
        path="/admin/list"
        icon={<IconList />}
        onClick={() => setOpen(false)}
      />
      <Item
        name="アカウント一覧"
        path="/admin/accounts"
        icon={<IconAccounts />}
        onClick={handleAccountList}
      />
      <Item
        name="パスワード変更"
        path="/admin/password"
        icon={<IconPassword />}
        onClick={() => setOpen(false)}
      />
      <Item
        name="ログアウト"
        path="/login"
        icon={<IconLogout />}
        onClick={handleLogout}
      />
    </List>
  );
};

export default MenuItem;
